import { workshopName } from '@edgvr-front/workshops/domain';
import { dataWorkshopEntityId } from './dataWorkshopEntityId';
import { dataId } from './dataId';
import { dataVORaw } from './dataVORaw';
import { dataStartedAt } from './dataStartedAt';

export const dataWorkshopEntityRaw = {
  type: 'object',
  required: ['id', 'workshopName', 'dataId', 'data', 'startedAt'],
  properties: {
    id: dataWorkshopEntityId,
    workshopName,
    dataId,
    data: dataVORaw,
    startedAt: dataStartedAt,
  },
  additionalProperties: false,
};
